import styled from "styled-components";
import { CorporateTheme } from "../../../utils/themes";

interface StyledCheckProps {
  size?: number;
  value?: boolean;
  borderColor?: string;
  bgColor?: string;
}

export const StyledCheck = styled.span<StyledCheckProps>`
  height: ${(props) => (props?.size ? `${props?.size}px` : "20px")};
  width: ${(props) => (props?.size ? `${props?.size}px` : "20px")} !important;
  border-radius: ${(props) => (props?.size ? `${props?.size / 4}px` : "6px")};
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.white};
  transition: background-color 0.3s ease;
  background-color: ${({ bgColor }) => bgColor};
  border: 1px solid ${({ borderColor }) => borderColor??CorporateTheme?.colors?.border};
  cursor: pointer;
  min-width: ${(props) => (props?.size ? `${props?.size}px` : "20px")} !important;
  min-height: ${(props) => (props?.size ? `${props?.size}px` : "20px")};
  svg {
    fill: currentColor;
  }
`;
